export const siteInfo = {
  name: '17黑料网',
  corePositioning: '网红黑料吃瓜视频最新在线平台',
  slogan: '每日更新，一站吃遍全网黑料',
  description1: '17黑料网专注黑料吃瓜内容聚合，实时追踪网红圈、娱乐圈最新动态，为你带来第一手吃瓜黑料视频与深度爆料。无论是最新塌房内幕、直播翻车名场面，还是明星八卦实锤，这里都有最全最热的17黑料吃瓜网资源。',
  description2: '平台每日精选最新17吃瓜黑料与17吃瓜黑料网内容，覆盖千万粉丝博主、知名网红、选秀艺人等热门话题，持续更新黑料吃瓜最新动态，是全网吃瓜群众的聚集地。',
  stats: [
    { label: '每日更新', value: '50+' },
    { label: '覆盖网红', value: '3000+' },
    { label: '在线吃瓜', value: '24h' },
  ],
  heroImage: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20art%20composition%20with%20warm%20crimson%20and%20deep%20amber%20tones%20artfully%20blended%20together%20floating%20translucent%20social%20media%20notification%20icons%20and%20entertainment%20news%20elements%20suspended%20in%20atmospheric%20space%20modern%20editorial%20design%20aesthetic%20with%20subtle%20geometric%20line%20patterns%20and%20organic%20flowing%20shapes%20dark%20gradient%20overlay%20creating%20depth%20cinematic%20dramatic%20atmosphere%20with%20soft%20directional%20lighting%20high%20contrast%20artistic%20composition%20sophisticated%20visual%20language&width=800&height=600&seq=hero-main-2026&orientation=landscape',
};

export const appEntry = {
  title: '17黑料吃瓜 App',
  description: '随时随地刷最新黑料吃瓜视频，iOS / Android 双端支持，推送不遗漏任何一个热门黑料。',
  qrLabel: '扫码下载 App',
};

export const topics = [
  { id: 1, name: '网红塌房', heat: '98.7w', badge: '爆', badgeColor: 'bg-primary-500' },
  { id: 2, name: '最新爆料', heat: '87.3w', badge: '热', badgeColor: 'bg-accent-500' },
  { id: 3, name: '吃瓜合集', heat: '76.5w', badge: '热', badgeColor: 'bg-accent-500' },
  { id: 4, name: '明星八卦', heat: '72.1w', badge: '新', badgeColor: 'bg-secondary-500' },
  { id: 5, name: '直播翻车', heat: '68.9w', badge: '热', badgeColor: 'bg-accent-500' },
  { id: 6, name: '综艺名场面', heat: '65.4w', badge: '', badgeColor: '' },
  { id: 7, name: '恋爱实锤', heat: '62.3w', badge: '新', badgeColor: 'bg-secondary-500' },
  { id: 8, name: '带货争议', heat: '58.7w', badge: '', badgeColor: '' },
  { id: 9, name: '选秀内幕', heat: '55.2w', badge: '', badgeColor: '' },
  { id: 10, name: '抄袭风波', heat: '51.8w', badge: '', badgeColor: '' },
  { id: 11, name: '跨界话题', heat: '48.6w', badge: '', badgeColor: '' },
];

export const rankingItems = [
  { rank: 1, title: '某千万粉丝博主被爆私下言论不当，引发全网热议与脱粉潮', heat: '125.6w', tag: '24小时热榜' },
  { rank: 2, title: '知名女网红与经纪公司解约内幕曝光，粉丝阵营两极分化', heat: '98.3w', tag: '' },
  { rank: 3, title: '顶流带货主播直播翻车，产品功效遭专业人士打假质疑', heat: '87.1w', tag: '' },
  { rank: 4, title: '选秀节目选手被爆校园霸凌黑历史，节目组紧急发声明', heat: '75.4w', tag: '新上榜' },
  { rank: 5, title: '某美食博主被实锤使用预制菜冒充现做，塌房来得猝不及防', heat: '68.9w', tag: '' },
  { rank: 6, title: '娱乐圈知名夫妻档疑似婚变，社交账号相互取关引猜测', heat: '62.7w', tag: '' },
  { rank: 7, title: '说唱歌手新歌被指抄袭国外小众音乐人，粉丝控评大战升级', heat: '55.2w', tag: '' },
];

export const aboutContent = {
  title: '关于17黑料网',
  paragraphs: [
    '17黑料网是国内领先的黑料吃瓜内容聚合平台，始终秉承"真实、快速、全面"的理念，致力于为广大吃瓜群众提供最新、最全的网红黑料吃瓜视频与17黑料吃瓜网资源。我们拥有一支专业的吃瓜编辑团队，7×24小时不间断追踪各大社交平台、直播平台的第一手动态，确保用户永远能吃到最新鲜的黑料。',
    '作为17吃瓜黑料网领域的先行者，我们不仅提供及时的热门事件报道，更注重内容的深度与广度。每一条17吃瓜黑料都经过多方核实与交叉验证，同时保持客观中立的立场，让用户在享受吃瓜乐趣的同时也能了解事件全貌。',
    '17黑料网每日更新热门黑料吃瓜动态五十余条，涵盖网红塌房、明星八卦、直播翻车、带货争议、选秀内幕等多个维度，已成为全网吃瓜爱好者的首选信息站。未来，我们将持续优化内容生态，打造更丰富、更专业的黑料吃瓜在线体验。',
  ],
  image: 'https://readdy.ai/api/search-image?query=Warm%20modern%20editorial%20workspace%20with%20multiple%20screens%20displaying%20social%20media%20feeds%20and%20entertainment%20news%20monitoring%20dashboard%20professional%20content%20curation%20environment%20warm%20ambient%20lighting%20with%20subtle%20crimson%20accent%20details%20clean%20minimalist%20workspace%20with%20plants%20sophisticated%20atmosphere%20editorial%20photography%20style&width=640&height=480&seq=about-section-2026&orientation=landscape',
};

export const indexItems = [
  { id: 1, title: '塌房实录', desc: '网红翻车现场全纪录', count: '128篇', icon: 'ri-alert-line' },
  { id: 2, title: '爆料专区', desc: '第一手独家内幕消息', count: '96篇', icon: 'ri-spy-line' },
  { id: 3, title: '黑料视频', desc: '实锤视频证据合集', count: '215条', icon: 'ri-video-line' },
  { id: 4, title: '明星八卦', desc: '娱乐圈最新动态追踪', count: '187篇', icon: 'ri-star-line' },
  { id: 5, title: '直播翻车', desc: '直播间名场面大赏', count: '73条', icon: 'ri-live-line' },
  { id: 6, title: '带货打假', desc: '网红带货争议与真相', count: '54篇', icon: 'ri-shopping-bag-line' },
  { id: 7, title: '恋爱实锤', desc: '网红恋情曝光合集', count: '92篇', icon: 'ri-heart-line' },
  { id: 8, title: '今日吃瓜', desc: '每日最新吃瓜汇总', count: '365期', icon: 'ri-calendar-check-line' },
];

export const faqItems = [
  {
    q: '17黑料网的内容来源是什么？',
    a: '17黑料网的内容由专业编辑团队从全网各大社交平台、直播平台、短视频平台等公开渠道实时采集与整理，所有黑料吃瓜最新动态均经过多方交叉验证，确保信息的真实性和时效性。',
  },
  {
    q: '如何第一时间获取最新17吃瓜黑料？',
    a: '您可以收藏17黑料网首页并开启浏览器通知，或关注我们的社交媒体账号。网站每日更新五十余条黑料吃瓜视频与最新爆料内容，首页热度榜单实时刷新，确保您永不错过任何一个热门黑料。',
  },
  {
    q: '17黑料网的内容是否收费？',
    a: '17黑料网所有黑料吃瓜在线内容均为免费浏览，无需注册即可访问全部吃瓜黑料视频与爆料文章。我们致力于为全网吃瓜群众提供一个开放、免费的信息获取平台。',
  },
  {
    q: '可以向17黑料网投稿或爆料吗？',
    a: '当然可以！我们非常欢迎广大吃瓜群众提供线索与爆料。您可以通过页面底部的联系方式或投稿入口提交信息，我们的编辑团队会在核实后优先发布，并保护爆料人的隐私安全。',
  },
  {
    q: '17黑料网的内容更新频率如何？',
    a: '17黑料网实行7×24小时滚动更新机制，编辑团队全天候值守。高峰期每小时更新多条热门动态，确保17今日吃瓜内容始终处于最新状态。特殊事件期间更新频率还会进一步提高。',
  },
  {
    q: '如何区分17黑料网内容的真实性等级？',
    a: '我们对每一条17吃瓜黑料都标注了信息来源与可信度等级：实锤（已有确凿证据）、爆料（多方信源交叉验证）、传闻（单一信源待证实），帮助读者理性判断与辨别。',
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20modern%20avatar%20portrait%20of%20a%20young%20Chinese%20person%20with%20warm%20lighting%20minimalist%20illustration%20style%20soft%20geometric%20design%20neutral%20expression%20clean%20background%20editorial%20quality&width=80&height=80&seq=avatar-01-2026&orientation=squarish',
    name: '吃瓜小能手',
    time: '2小时前',
    content: '17黑料网真的是我每天的快乐源泉！更新速度太快了，每次有大瓜都能第一时间在这里看到详细整理，比刷微博效率高多了。编辑团队辛苦了！',
    likes: 328,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20modern%20avatar%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20lighting%20minimalist%20illustration%20style%20soft%20geometric%20design%20friendly%20expression%20clean%20background%20editorial%20quality&width=80&height=80&seq=avatar-02-2026&orientation=squarish',
    name: '八卦研究员',
    time: '5小时前',
    content: '之前在其他平台看黑料总觉得信息不全，来了17黑料网才发现原来吃瓜可以这么系统。每次的专题合集梳理得特别清楚，时间线一目了然，强烈推荐！',
    likes: 256,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20modern%20avatar%20portrait%20of%20a%20young%20Chinese%20man%20with%20warm%20lighting%20minimalist%20illustration%20style%20soft%20geometric%20design%20cool%20expression%20clean%20background%20editorial%20quality&width=80&height=80&seq=avatar-03-2026&orientation=squarish',
    name: '前排吃瓜群众',
    time: '8小时前',
    content: '收藏了这个网站以后每天都要来刷好几次，最爱看17黑料吃瓜视频板块，实锤证据摆得明明白白。而且分类做得很好，想找什么类型的黑料都很方便。',
    likes: 189,
  },
];

export const contactInfo = {
  title: '投稿爆料 / 商务合作',
  description: '如果你有最新黑料线索、吃瓜素材或商务合作需求，欢迎通过以下方式联系我们。我们承诺严格保护爆料人隐私信息。',
  email: 'tips@17heiliao.com',
  wechat: '17heiliao_wx',
  response: '投稿将在24小时内审核回复',
};

export const updatesData = [
  { id: 1, time: '07-30 14:32', title: '某游戏主播被实锤使用外挂，直播间被封禁72小时', tag: '最新' },
  { id: 2, time: '07-30 11:15', title: '知名美妆博主产品测评翻车，粉丝晒图对比打脸', tag: '热议' },
  { id: 3, time: '07-30 09:08', title: '选秀节目选手被爆与导师私下关系密切引争议', tag: '新瓜' },
  { id: 4, time: '07-29 22:45', title: '网传某顶流男星与女演员深夜密会，双方暂未回应', tag: '' },
  { id: 5, time: '07-29 18:20', title: '短视频平台网红因不当言论被官方点名批评下架视频', tag: '热议' },
  { id: 6, time: '07-29 15:56', title: '带货主播双十一预售数据造假疑云，平台启动调查', tag: '' },
  { id: 7, time: '07-29 10:03', title: '说唱综艺选手抄袭事件持续发酵，原唱发声维权', tag: '跟进' },
];

export const cardsData = [
  {
    id: 1,
    title: '千万粉博主塌房全记录',
    desc: '从巅峰到崩塌，72小时时间线完整还原这场年度最大黑料吃瓜事件',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20photography%20style%20smartphone%20screen%20displaying%20colorful%20social%20media%20feed%20with%20notification%20badges%20warm%20ambient%20lighting%20soft%20shadows%20clean%20cream%20background%20shallow%20depth%20of%20field%20sophisticated%20composition%20warm%20neutral%20tones&width=600&height=400&seq=card-01-2026&orientation=landscape',
    badge: '年度大瓜',
  },
  {
    id: 2,
    title: '直播带货打假实录',
    desc: '盘点近期最离谱的直播带货翻车事件，产品功效遭专业人士逐条打假',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20representing%20digital%20entertainment%20news%20with%20overlapping%20geometric%20circles%20in%20warm%20crimson%20and%20amber%20gradients%20subtle%20paper%20texture%20overlay%20modern%20editorial%20design%20elements%20minimalist%20aesthetic%20warm%20neutral%20background&width=600&height=400&seq=card-02-2026&orientation=landscape',
    badge: '热门',
  },
  {
    id: 3,
    title: '网红恋爱瓜年度盘点',
    desc: '2026上半年最劲爆的网红恋情曝光合集，那些官宣、实锤与反转',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20photography%20of%20glowing%20neon%20entertainment%20news%20headlines%20floating%20in%20dark%20atmospheric%20space%20warm%20red%20and%20gold%20light%20trails%20modern%20aesthetic%20sophisticated%20nighttime%20urban%20vibe%20soft%20bokeh%20effects%20cinematic%20composition&width=600&height=400&seq=card-03-2026&orientation=landscape',
    badge: '合集',
  },
  {
    id: 4,
    title: '选秀节目黑幕大揭秘',
    desc: '知情人爆料选秀圈内幕操作，选手合同、投票机制、剪辑手法的真相',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20gradient%20background%20with%20overlapping%20translucent%20circles%20and%20subtle%20wave%20patterns%20in%20amber%20and%20coral%20minimalist%20modern%20design%20soft%20diffused%20lighting%20clean%20sophisticated%20aesthetic%20editorial%20quality&width=600&height=400&seq=card-04-2026&orientation=landscape',
    badge: '独家',
  },
  {
    id: 5,
    title: '抄袭风波连环爆',
    desc: '音乐、设计、文案接连被锤，创意行业抄袭乱象何时休？事件全梳理',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20still%20life%20composition%20of%20vintage%20newspapers%20and%20modern%20smartphone%20side%20by%20side%20on%20warm%20wooden%20surface%20evolution%20of%20media%20concept%20soft%20natural%20window%20lighting%20warm%20neutral%20tones%20with%20crimson%20accent%20details%20editorial%20photography&width=600&height=400&seq=card-05-2026&orientation=landscape',
    badge: '深度',
  },
  {
    id: 6,
    title: '综艺名场面大赏',
    desc: '那些让观众目瞪口呆的综艺神级翻车与意外名场面，每一帧都是经典',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20fluid%20gradient%20composition%20blending%20warm%20crimson%20to%20amber%20tones%20with%20subtle%20geometric%20grid%20overlay%20modern%20minimalist%20design%20aesthetic%20soft%20ethereal%20lighting%20sophisticated%20artistic%20background%20for%20digital%20content%20display%20clean%20contemporary&width=600&height=400&seq=card-06-2026&orientation=landscape',
    badge: '热门',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '2026上半年网红塌房大盘点',
    desc: '从千万粉丝博主到新晋网红，盘点今年最震撼的塌房事件全记录，每一起都让人意想不到。话题涵盖直播翻车、人设崩塌、带货造假、私生活曝光等多个维度，一文读懂上半年吃瓜精华。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20wide%20cinematic%20composition%20of%20abstract%20social%20media%20landscape%20with%20towering%20translucent%20notification%20pillars%20in%20warm%20crimson%20and%20amber%20light%20digital%20entertainment%20metropolis%20concept%20atmospheric%20fog%20and%20soft%20volumetric%20lighting%20epic%20scale%20modern%20editorial%20photography%20high%20detail&width=960&height=540&seq=carousel-01-2026&orientation=landscape',
    badge: '年度专题',
  },
  {
    id: 2,
    title: '直播带货行业信任危机',
    desc: '从虚假宣传到产品翻车，直播间里那些你不知道的秘密正在被逐一揭开。本文深度调查带货主播的选品流程、佣金机制以及售后黑幕，还原一个真实的直播带货江湖。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20wide%20panoramic%20composition%20of%20floating%20geometric%20abstract%20shapes%20representing%20trending%20topics%20and%20viral%20content%20warm%20golden%20hour%20lighting%20with%20crimson%20accent%20highlights%20sophisticated%20modern%20design%20ethereal%20atmospheric%20quality%20editorial%20magazine%20spread%20style&width=960&height=540&seq=carousel-02-2026&orientation=landscape',
    badge: '深度调查',
  },
  {
    id: 3,
    title: '网红经济的AB面：流量背后的代价',
    desc: '光鲜亮丽的网红生活背后，是巨大的压力、资本博弈与人性考验。本文从行业生态出发，深度解析网红经济的双面性，探讨流量狂欢之下那些不为人知的故事与反思。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20composition%20of%20intersecting%20light%20beams%20and%20abstract%20data%20visualization%20elements%20in%20warm%20amber%20and%20deep%20red%20tones%20representing%20digital%20information%20flow%20and%20entertainment%20media%20modern%20sophisticated%20aesthetic%20dramatic%20contrast%20with%20soft%20gradients&width=960&height=540&seq=carousel-03-2026&orientation=landscape',
    badge: '行业观察',
  },
  {
    id: 4,
    title: '从素人到顶流：网红成名路径全解析',
    desc: 'MCN机构如何批量制造网红？一夜爆红背后的运营逻辑与流量密码到底是什么？本文拆解了当下最热门的网红孵化模式，从内容策划到人设打造，完整呈现网红产业的运作全貌。',
    image: 'https://readdy.ai/api/search-image?query=Wide%20atmospheric%20composition%20of%20abstract%20organic%20flowing%20forms%20representing%20the%20dynamic%20nature%20of%20online%20entertainment%20news%20warm%20coral%20and%20amber%20tones%20with%20subtle%20crimson%20depth%20accents%20soft%20dreamy%20lighting%20modern%20artistic%20interpretation%20editorial%20quality&width=960&height=540&seq=carousel-04-2026&orientation=landscape',
    badge: '产业揭秘',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时滚动追踪，第一时间呈现最新17黑料吃瓜视频与动态，永远快人一步。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多方验证',
    desc: '每条17吃瓜黑料均经过编辑团队交叉验证，确保内容真实可靠不翻车。',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: '海量内容',
    desc: '涵盖塌房、爆料、八卦、翻车、争议等全维度黑料吃瓜最新资源，一站全收。',
  },
  {
    id: 4,
    icon: 'ri-user-heart-line',
    title: '吃瓜社区',
    desc: '百万吃瓜群众在线互动，一起讨论最热网红黑料吃瓜话题，吃瓜不孤单。',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '千万粉博主塌房72小时全程回顾',
    desc: '从爆料到实锤，完整时间线还原',
    duration: '12:38',
    views: '256.8w',
    image: 'https://readdy.ai/api/search-image?query=Modern%20studio%20photography%20of%20a%20content%20creator%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%20against%20warm%20minimalist%20background%20representing%20video%20content%20creation%20and%20live%20streaming%20soft%20natural%20lighting%20clean%20aesthetic%20warm%20neutral%20tones%20editorial%20quality&width=640&height=360&seq=media-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '直播带货翻车名场面合集',
    desc: '那些尴尬到脚趾抠地的直播瞬间',
    duration: '08:15',
    views: '189.3w',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20closeup%20of%20abstract%20play%20button%20icon%20formed%20by%20flowing%20liquid%20metal%20in%20warm%20amber%20and%20crimson%20tones%20modern%20minimalist%20design%20soft%20dramatic%20lighting%20sophisticated%20visual%20metaphor%20for%20video%20media%20content%20high%20end%20editorial%20style&width=640&height=360&seq=media-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '网红恋爱瓜时间线大梳理',
    desc: '从暗戳戳到官宣，所有蛛丝马迹',
    duration: '15:42',
    views: '312.1w',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20composition%20of%20floating%20translucent%20screens%20displaying%20abstract%20entertainment%20content%20in%20warm%20atmospheric%20space%20modern%20media%20consumption%20concept%20soft%20golden%20and%20crimson%20lighting%20sophisticated%20contemporary%20design%20language&width=640&height=360&seq=media-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '选秀节目内幕知情人专访',
    desc: '揭开选秀行业不为人知的操作规则',
    duration: '22:10',
    views: '145.7w',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20representation%20of%20video%20timeline%20with%20warm%20toned%20gradient%20segments%20and%20subtle%20geometric%20markers%20modern%20minimalist%20media%20player%20interface%20aesthetic%20soft%20ambient%20lighting%20clean%20sophisticated%20design%20warm%20neutral%20background&width=640&height=360&seq=media-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '2026年度吃瓜大事件TOP10',
    desc: '盘点今年最劲爆的黑料吃瓜名场面',
    duration: '18:55',
    views: '398.4w',
    image: 'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20composition%20of%20abstract%20sound%20waves%20and%20visual%20rhythm%20patterns%20in%20amber%20and%20deep%20coral%20tones%20representing%20digital%20media%20and%20entertainment%20content%20modern%20artistic%20interpretation%20soft%20cinematic%20lighting%20high%20end%20editorial%20quality&width=640&height=360&seq=media-05-2026&orientation=landscape',
  },
];